<template>
  <section class="services-section">
    <div class="container">
      <div class="section-header">
        <h4 class="brand-tag">{{ $t('howBrand') }}</h4>
        <h2>{{ $t('howHeader') }}</h2>
        <p class="section-intro">{{ $t('howIntro') }}</p>
      </div>

      <Swiper
        :modules="modules"
        :slides-per-view="1"
        :space-between="20"
        :loop="true"
        :pagination="{ clickable: true }"
        :autoplay="{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }"
        :breakpoints="{
          '768': { slidesPerView: 2, spaceBetween: 30 },
          '1200': { slidesPerView: 3, spaceBetween: 40 }
        }"
        class="services-swiper"
      >
        <SwiperSlide>
          <div class="service-card">
            <div class="card-icon">🚀</div>
            <h3>{{ $t('howServiceTitle_1') }}</h3>
            <p>{{ $t('howServiceDesc_1') }}</p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="service-card">
            <div class="card-icon">⚙️</div>
            <h3>{{ $t('howServiceTitle_2') }}</h3>
            <p>{{ $t('howServiceDesc_2') }}</p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="service-card">
            <div class="card-icon">⚡</div>
            <h3>{{ $t('howServiceTitle_3') }}</h3>
            <p>{{ $t('howServiceDesc_3') }}</p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="service-card">
            <div class="card-icon">🛡️</div>
            <h3>{{ $t('howServiceTitle_4') }}</h3>
            <p>{{ $t('howServiceDesc_4') }}</p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="service-card">
            <div class="card-icon">☁️</div>
            <h3>{{ $t('howServiceTitle_5') }}</h3>
            <p>{{ $t('howServiceDesc_5') }}</p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div class="service-card">
            <div class="card-icon">🔐</div>
            <h3>{{ $t('howServiceTitle_6') }}</h3>
            <p>{{ $t('howServiceDesc_6') }}</p>
          </div>
        </SwiperSlide>
      </Swiper>

      <div class="section-footer">
        <a href="/contact" class="secondary-link">
        {{ $t('letsDiscussProject') }}<span class="arrow">→</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Autoplay } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

export default {
  name: 'HowWeCanHelp',
  components: {
    Swiper,
    SwiperSlide
  },
  setup () {
    return {
      modules: [Pagination, Autoplay]
    }
  }
}
</script>

<style scoped>

.services-swiper {
  padding: 20px 0 60px;
}

.swiper-slide {
  height: auto !important;
  display: flex;
}

.service-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 40px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  margin: 10px 5px;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(6, 45, 69, 0.1);
  border-color: var(--secondary-color);
}

.card-icon {
  font-size: 2.5rem;
  margin-bottom: 20px;
  background: rgba(43, 189, 211, 0.1);
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
}

.service-card h3 {
  color: var(--primary-color);
  margin-bottom: 15px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.brand-tag {
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 2px;
}

.secondary-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--primary-color);
  font-weight: bold;
  margin-top: 30px;
}

.arrow {
  background: var(--secondary-color);
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-slide {
  height: auto !important;
  display: flex;
}

.services-swiper {
  padding: 20px 0 60px;
}

.service-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 40px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  margin: 10px 5px;
}

.services-swiper {
  padding: 20px 0 60px;
}

.service-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 40px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  margin: 10px 5px;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(6, 45, 69, 0.1);
  border-color: var(--secondary-color);
}

.services-section {
  padding: 100px 0;
  background-color: #FFFFFF;
}
.section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 60px;
}

.brand-tag {
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 0.9rem;
  margin-bottom: 10px;
}

.section-intro {
  color: var(--text-color);
  opacity: 0.8;
  font-size: 1.1rem;
}

.card-icon {
  font-size: 2.5rem;
  margin-bottom: 20px;
  background: rgba(43, 189, 211, 0.1);
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
}

.service-card h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.5rem;
  color: var(--primary-color);
}

.service-card p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 0;
}

.section-footer {
  text-align: center;
  margin-top: 20px;
}

.secondary-link {
  font-family: var(--secondary-font);
  color: var(--primary-color);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.secondary-link .arrow {
  background: var(--secondary-color);
  color: white;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.secondary-link:hover .arrow {
  transform: translateX(5px);
}
</style>
